import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  chatIconContainer: {position: 'absolute', bottom: 20, right: 0},
});
